<template>
    <div
        class="block-row__wrapper"
        :class="wrapperClasses">

        <picture
            v-if="picture"
            class="block-row__picture"
            :class="pictureClasses">

            <img v-lazy-load :data-src="picture"
                :alt="name" />

        </picture>

        <div class="block-row__name"> {{ name }}</div>

        <div class="block-row__caption">
            {{ caption }}

            <slot name="icon">

                <svg-icon
                    class="block-row__icon"
                    name="chevron-right-gray"/>

            </slot>
        </div>

        <html-link
            v-if="url"
            :url="url"
            :aria-label="name"
            class="block-row__link" />
        <html-link
            v-else-if="routeTo"
            :to="routeTo"
            :aria-label="name"
            class="block-row__link" />
        <a v-else-if="link"
            rel="nofollow"
            target="_blank"
            :href="link"
            :aria-label="name"
            class="block-row__link"></a>
    </div>
</template>

<script>
import get from 'lodash/get';
import includes from 'lodash/includes'
import OfferMixin from '@/mixins/catalog/offers.mixin'

export default {
    name: 'BlockRow',
    mixins: [ OfferMixin ],
    props: {
        nameCenter: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: null,
            validator(value) {
                return includes(['xs'], value)
            }
        },
        border: {
            type: Boolean,
            default: false
        },
        iconPlaceholder: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        wrapperClasses() {
            return {
                'block-row__wrapper_pictured': get(this.picture, 'length', false),
                'block-row__wrapper_xs': this.size === 'xs',
                'block-row__wrapper_border': this.border,
                'block-row__wrapper_name-center': this.nameCenter,
            }
        },
        pictureClasses() {
            return {
                'block-row__picture_placeholder': this.iconPlaceholder,
            }
        }
    },
    methods: {
        get
    }
};
</script>

<style lang="less">
.block-row {
    &__wrapper {
        display: flex;
        justify-content: space-between;

        padding-top: rem(20);
        padding-bottom: rem(20);

        width: 100%;

        position: relative;

        .page-padding();

        .animate(box-shadow);

        &:hover {
            @media @hover {
                box-shadow: @menu-desktop-box-shadow-hover;
            }
        }

        &_pictured {
            padding: rem(10) @dim-page-padding;
        }

        &_xs {
            font-weight: 500
        }

        &_border {
            border: rem(1) solid @color-gray-white;
            border-radius: rem(3);

            transition: box-shadow 0.2s;

            @{desktop} & {
                padding-right: rem(20);
                padding-left: rem(20);
            }

            &:hover {
                box-shadow: 0 rem(1) rem(8) rgba(0, 0, 0, 0.1);

                transition: box-shadow 0.2s;
            }
        }
    }

    &__wrapper_xs &__picture {
        --size: rem(32);
    }

    &__wrapper_xs &__name {
        font-size: rem(13);
    }

    &__wrapper_xs &__caption {
        color: @color-black;

        padding-top: rem(1) !important;
    }

    &__picture {
        --size: rem(44);

        display: block;

        border-radius: 50%;

        margin-right: rem(14);

        height: var(--size);
        width: var(--size);

        overflow: hidden;

        transition: transform .2s ease-in;

        transform: scale(.9);

        img {
            object-fit: contain;

            height: 100%;
            width: 100%;
        }

        &_placeholder {
            display: flex;
            align-items: center;
            justify-content: center;

            background-color: @color-gray-light-2;

            padding: rem(10);
        }
    }

    &__picture ~ &__caption {
        padding-top: rem(6);

        @{desktop} & {
            padding-top: rem(2);
            padding-right: rem(3);
        }
    }

    &__picture ~ &__caption &__icon {
        height: rem(15);
        width: rem(15);

        top: rem(-2);
        right: rem(-5);

        @{desktop} & {
            top: rem(-1);
            right: rem(-8);
        }
    }

    &__name {
        .text-ellipsis(1);
        display: block;

        font-size: rem(15);
        font-weight: 500;
        white-space: nowrap;

        margin-right: auto;

        max-width: 70%;
    }

    &__wrapper_name-center &__name {
        display: flex;
        align-items: center;
    }

    &__caption {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding-top: rem(2);

        color: @color-gray;
        font-size: rem(13);

        max-width: calc(100% - 67%);
    }

    &__icon {
        margin-left: rem(5);

        height: rem(18);
        width: rem(18);

        position: relative;
        right: rem(-5);
    }

    &__link {
        height: 100%;
        width: 100%;

        position: absolute;
        top: 0;
        left: 0;
    }

}
</style>
